import { AnalyticsEventLocation } from '@mb/lib';
import { TreatmentVariant } from '../../types';

interface IAnalyticsEvent {
  event: AnalyticsEventName;
  event_location: AnalyticsEventLocation;
  action: AnalyticsEventAPQAction;
  type?: AnalyticsEventContactType | string;
  experiment_name?: string;
  experiment_version?: TreatmentVariant;
}

export enum AnalyticsEventName {
  APQ = 'apq',
  CONTACT_REP = 'contact_rep',
}

export const sendAnalyticsEvent = (params: IAnalyticsEvent) => {
  mitGTM.sendEvent(params);
};

export enum AnalyticsEventContactType {
  REQUEST_INFORMATION = 'Request information',
  MEETING_REQUEST = 'Meeting request',
  CONTACT_ME = 'Yes connect',
  DISMISS_BRAND = 'Dismiss brand',
  REQUEST_QUOTE = 'Request quote',
  REQUEST_SPECIFICATION = 'Request specification',
  REQUEST_LEAD_TIME = 'Lead time',
  REQUEST_INSTALLATION_SHOTS = 'Request installation shots',
  REQUEST_SUSTAINABILITY = 'Request sustainability',
  READY_TO_SPECIFY = 'Ready to specify',
  REQUEST_PRICING = 'Pricing',
  REQUEST_PRODUCT_AVAILABILITY = 'Product availability',
  NOT_READY_TO_CONNECT = 'Not ready to connect',
}

export enum AnalyticsEventAPQAction {
  OPEN = 'Open',
  CLOSE = 'Close',
  CLICK_OFF = 'Click off',
  FILTER_PROJECT = 'Filter Project',
  EXPAND_BRAND_SAMPLES = 'Expand brand samples',
  COLLAPSE_BRAND_SAMPLES = 'Collapse brand samples',
  SEE_MORE_BRAND_SAMPLES = 'See more brand samples',
  NUDGE = 'Nudge',
  BACK_TO_MODAL = 'Back to modal',
  CONFIRM_CLOSE = 'Confirm close',
  ALL_CLEARED = 'All cleared',
  SEND_MESSAGE = 'Send message',
  DISMISS_BRAND = 'Dismiss brand',
}

export enum AnalyticsEventContactRepType {
  PRICING = 'Pricing',
  LEAD_TIME = 'Lead time',
  INSTALLATION_IMAGES = 'Installation images',
  REQUEST_MEETING = 'Request meeting',
  OTHER = 'Other',
  PERSONAL_MESSAGE = 'Personal message',
}
